import React from 'react';
import PlanMobile from '../plan-mobile';
const CompactPlans = ({
  isLoading = false,
  plans,
  withIntroPriceDiscounts = false,
  collapseHiddenText = '',
  collapseOpenText = '',
}) => (
  <div className="ws-ui-compact-plans">
    {plans.map((item) => (
      <PlanMobile
        {...item}
        key={item.type + item.captions.name}
        collapseHiddenText={collapseHiddenText}
        collapseOpenText={collapseOpenText}
        isLoading={isLoading}
        withIntroPriceDiscounts={withIntroPriceDiscounts}
      />
    ))}
  </div>
);

export default CompactPlans;
